<template>
  <div class="notfound">
    <el-image :src="notFound" />
  </div>
</template>

<script>
export default {
  name: '404',
  data () {
    return {
      notFound: require('@assets/imgs/404.png')
    }
  },
  mounted () {
    this.$store.commit('UPDATE_BreadMenuData', [])
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.notfound{
  display: flex;
  margin-top:-15px;
  height: calc(100vh - 100px);
  background-color: #fff;
  @extend .comBackground;
  align-items: center;
  justify-content: center;
}
</style>
